import Footer from 'components/footer/Footer';
import PageHeader from 'components/page-header/PageHeader';
import InternalRouter from 'navigation/pages/InternalRouter';
export default class Advices extends InternalRouter {
    static pageName = 'Advices';
    getModulesMap() {
        return {
            ...super.getModulesMap(),
            pageHeader: ['.page-header', PageHeader],
            footer: ['footer', Footer]
        };
    }
    initialized() {
        super.initialized();
    }
    getPageSelector() {
        return '.advices__inner';
    }
}
